import {defineStore} from "pinia";
import {PersonContext} from "@/authentication/AuthenticationService";

export interface ApplicationContext {
    locale: string
}

export const useApplicationStore = defineStore('applicationStore', {
    state: () => {
        return {
            context: {} as ApplicationContext,
            person: {} as PersonContext | undefined
        }
    },
    getters: {},
    actions: {
        updatePerson(person: PersonContext | undefined) {
            this.person = person
        },
        clearLoggedInPerson() {
            this.person = undefined
        }
    }
})